<template>
  <DBox
    :addButton="false"
    :addLink="false"
    :id="'cmp-booking-promoters-promoter-custom_fields'"
    :topRightMenu="[
      {
        html: this.$t('promoter_custom_fields_hints'),
        icon: 'Help2.svg',
        value: 'question',
      },
    ]"
  >
    <TextField2
      v-for="(field, index) in (customFields || [])"
      :key="field.custom_field_id"
      id="data"
      :placeholder="field.field_label"
      :label="field.field_label"
      :value="field.data"
      :disabled="false"
      @blur="(e) => onTextFieldValueChange(e, field)"
    />
  </DBox>
</template>

<script>

export default {
  components: {
  },
  props: ["customFields"],
  data: function () {
    return {
    };
  },
  mounted: function () {},
  computed: {
  },
  methods: {
    onTextFieldValueChange: function (event, item) {
      const { name, value } = event;
      const { custom_data_id } = item;
      // console.log('field: ', item);
      this.$emit("changed", { custom_data_id, value });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.cmp-booking-promoters-promoter-custom_fields {
  // .fc2-textfield {
  //   &:last-child {
  //     border-bottom: none !important;
  //   }
  // }
}
</style>
